(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.BackArrow = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var BackArrow = function BackArrow() {
    return _react2.default.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      },
      _react2.default.createElement("path", {
        fill: "#2D344B",
        fillRule: "evenodd",
        d: "M23 10.667H5.681l4.376-4.787L8.333 4 1 12l7.333 8 1.724-1.88-4.376-4.787H23z"
      })
    );
  };

  exports.default = BackArrow;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/svg/BackArrow.js
// module id = 762
// module chunks = 1